module.exports = __webpack_public_path__ + "static/img/6.efde180.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6.png
// module id = 202
// module chunks = 1